<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">導師夜間輔導紀錄表</span>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <form-input v-model="vm.SYear" id="SYear" label="學年度" type="number" required></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                    <div is="option" value="u">上</div>
                    <div is="option" value="d">下</div>
                </form-select>
            </div>
            <!--<div class="col-12">
                <form-input v-model="vm.ClassID" id="ClassID" label="班級" type="text" classlist required></form-input>
            </div>-->
            <div class="col-12">
                <form-input v-model="vm.TeacherNo" id="TeacherNo" label="教師編號" type="text" required></form-input>
            </div>
            <div class="col-12">
                <form-date-input v-model="vm.Date" id="Date" label="日期" required></form-date-input>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.House" id="House" label="宿舍" required>
                    <div is="option" v-for="o in houses" :key="o.key" :value="o.key">{{o.value}}</div>
                </form-select>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-input v-model="vm.Room" id="Room" label="寢室" type="text"></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.Time" id="Time" label="分鐘" type="number" required></form-input>
            </div>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'eveningcounsellingDetail',
        api: '/api/eveningcounselling/',
        data: { houses: [] },
        created: function () {
            this.$parameter.house().then((res) => { this.houses = res.data; });
        },
    });
</script>

<style>
</style>